module.exports = __webpack_public_path__ + "img/point.d500d94f.svg";